import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseRepository} from "./base/base.repository";
import {PostPayloadInterface} from "../models/post-payload.interface";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class BillingDataRepository extends BaseRepository{
  constructor(public httpClient: HttpClient) {
    super(httpClient);
    this.path = 'dashboard/admin/billing-data';
  }

  updateWithoutId(payload: PostPayloadInterface): Observable<any> {
    return super.updateWithoutId(payload);
  }
}
